import { SvgIcon, SvgIconProps } from '@mui/material';
import React, { ReactElement } from 'react';

export interface MinusBoxIconProps extends SvgIconProps {}

export const MinusBoxIcon = ({
  style,
  ...iconProps
}: MinusBoxIconProps): ReactElement => {
  style = {
    fontSize: '1em',
    ...style,
  };

  return (
    <SvgIcon style={style} {...iconProps} viewBox="0 0 19.5 19.5">
      <g transform="translate(-3.75 -3.75)">
        <path
          d="M6.5,4.5h14a2,2,0,0,1,2,2v14a2,2,0,0,1-2,2H6.5a2,2,0,0,1-2-2V6.5A2,2,0,0,1,6.5,4.5Z"
          transform="translate(0 0)"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          d="M12,18h8"
          transform="translate(-2.5 -4.5)"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
      </g>
    </SvgIcon>
  );
};
